const selectors = {
  selectSaleItem: '选择销售订单{{mode}}',
  multiple: '（多选）',
  single: '（单选）',
};

export default selectors;